
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  detectRuntime,
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.8.1
 * Query Engine version: 78caf6feeaed953168c64e15a249c3e9a033ebe2
 */
Prisma.prismaVersion = {
  client: "5.8.1",
  engine: "78caf6feeaed953168c64e15a249c3e9a033ebe2"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  throw new Error(`Extensions.getExtensionContext is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.defineExtension = () => {
  throw new Error(`Extensions.defineExtension is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.CronTaskScalarFieldEnum = {
  id: 'id',
  taskName: 'taskName',
  enable: 'enable',
  runAt: 'runAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.InterfaceLogScalarFieldEnum = {
  id: 'id',
  apiName: 'apiName',
  callerIP: 'callerIP',
  body: 'body',
  result: 'result',
  refNo: 'refNo',
  info: 'info',
  error: 'error',
  isAchieved: 'isAchieved',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.InterfaceCustomerTierLogScalarFieldEnum = {
  id: 'id',
  refLogId: 'refLogId',
  result: 'result',
  info: 'info',
  error: 'error',
  pendingCount: 'pendingCount',
  processCount: 'processCount',
  successCount: 'successCount',
  failedCount: 'failedCount',
  skipCount: 'skipCount',
  isAchieved: 'isAchieved',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.InterfaceCustomerTierItemLogScalarFieldEnum = {
  id: 'id',
  customer_account: 'customer_account',
  customer_subscription: 'customer_subscription',
  customer_subscription_tier: 'customer_subscription_tier',
  subscription_quota_limit: 'subscription_quota_limit',
  subscription_quota_remain: 'subscription_quota_remain',
  subscription_total_amount: 'subscription_total_amount',
  updated_date: 'updated_date',
  interfaceId: 'interfaceId',
  isSuccess: 'isSuccess',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.InterfaceAX017LogScalarFieldEnum = {
  id: 'id',
  fileName: 'fileName',
  body: 'body',
  result: 'result',
  error: 'error',
  isAchieved: 'isAchieved',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.LogFrontEndScalarFieldEnum = {
  id: 'id',
  apiName: 'apiName',
  request: 'request',
  response: 'response',
  error: 'error',
  result: 'result',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.LogAxAPIScalarFieldEnum = {
  id: 'id',
  apiName: 'apiName',
  docNo: 'docNo',
  request: 'request',
  response: 'response',
  error: 'error',
  result: 'result',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CronJobExecutionScalarFieldEnum = {
  id: 'id',
  jobName: 'jobName',
  locked: 'locked',
  runAt: 'runAt'
};

exports.Prisma.ProductsPromotionScalarFieldEnum = {
  id: 'id',
  enable: 'enable',
  title: 'title',
  description: 'description',
  StartAt: 'StartAt',
  EndAt: 'EndAt',
  msProductIds: 'msProductIds',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AccountScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  expires_at: 'expires_at',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  sessionToken: 'sessionToken',
  expires: 'expires',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  customerAccount: 'customerAccount',
  name: 'name',
  email: 'email',
  password: 'password',
  emailVerified: 'emailVerified',
  image: 'image',
  level: 'level',
  isDeleted: 'isDeleted',
  isVerify: 'isVerify',
  isTempUser: 'isTempUser',
  onHoldStatus: 'onHoldStatus',
  requireOTPLogin: 'requireOTPLogin',
  isBanned: 'isBanned',
  isSuspended: 'isSuspended',
  isBlocked: 'isBlocked',
  suspendUntil: 'suspendUntil',
  blockUntil: 'blockUntil',
  defaultAddressId: 'defaultAddressId',
  defaultBillingAddressId: 'defaultBillingAddressId',
  customerSubscription: 'customerSubscription',
  customerSubscriptionTier: 'customerSubscriptionTier',
  subscriptionQuotaLimit: 'subscriptionQuotaLimit',
  subscriptionQuotaRemain: 'subscriptionQuotaRemain',
  subscriptionTotalAmount: 'subscriptionTotalAmount',
  latestSubscriptionSyncAt: 'latestSubscriptionSyncAt',
  ssoOTPhash: 'ssoOTPhash',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserProfileScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  firstName: 'firstName',
  middleName: 'middleName',
  lastName: 'lastName',
  idCard: 'idCard',
  xhashSum: 'xhashSum',
  dateOfBirth: 'dateOfBirth',
  email: 'email',
  telephone: 'telephone',
  verifiedTelephone: 'verifiedTelephone',
  isVerifyTelephone: 'isVerifyTelephone',
  latestTelephoneVerified: 'latestTelephoneVerified',
  gender: 'gender',
  nickName: 'nickName',
  lineId: 'lineId',
  facebookId: 'facebookId',
  introduction: 'introduction',
  bankAccount: 'bankAccount',
  bankAccountName: 'bankAccountName',
  bankAccountNumber: 'bankAccountNumber',
  sponsor: 'sponsor',
  titleCode: 'titleCode',
  placementSponsorCode: 'placementSponsorCode',
  registrationNumber: 'registrationNumber',
  createdFrom: 'createdFrom',
  associateToWebsite: 'associateToWebsite',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserCoApplicantScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  email: 'email',
  firstName: 'firstName',
  middleName: 'middleName',
  lastName: 'lastName',
  nickName: 'nickName',
  gender: 'gender',
  dateOfBirth: 'dateOfBirth',
  idCard: 'idCard',
  lineId: 'lineId',
  facebookId: 'facebookId',
  telephone: 'telephone',
  defaultAddressId: 'defaultAddressId',
  defaultBillingAddressId: 'defaultBillingAddressId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.VerificationTokenScalarFieldEnum = {
  id: 'id',
  identifier: 'identifier',
  token: 'token',
  expires: 'expires',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserTimelineScalarFieldEnum = {
  id: 'id',
  type: 'type',
  userId: 'userId',
  auditorUserId: 'auditorUserId',
  timelineTitle: 'timelineTitle',
  timelineNote: 'timelineNote',
  oldData: 'oldData',
  newData: 'newData',
  createdAt: 'createdAt'
};

exports.Prisma.AAA_DataMigrationScalarFieldEnum = {
  id: 'id',
  migration_code: 'migration_code',
  run_id: 'run_id',
  migration_time: 'migration_time',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.StaffScalarFieldEnum = {
  id: 'id',
  email: 'email',
  password: 'password',
  name: 'name',
  surname: 'surname',
  rolename: 'rolename',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.StaffRoleScalarFieldEnum = {
  id: 'id',
  roleName: 'roleName',
  roleLevel: 'roleLevel',
  desc: 'desc',
  permissionIDs: 'permissionIDs',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.MasterPlatformScalarFieldEnum = {
  id: 'id',
  platform: 'platform',
  enable: 'enable',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BackendZoneScalarFieldEnum = {
  id: 'id',
  zone: 'zone',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PermissionScalarFieldEnum = {
  id: 'id',
  fromPolicyName: 'fromPolicyName',
  description: 'description',
  zoneKey: 'zoneKey',
  actions: 'actions',
  staffRoleIDs: 'staffRoleIDs',
  policyName: 'policyName'
};

exports.Prisma.PolicyScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description'
};

exports.Prisma.CollectionAttbScalarFieldEnum = {
  id: 'id',
  collectionId: 'collectionId',
  loc: 'loc',
  title: 'title',
  body_html: 'body_html',
  meta_title: 'meta_title',
  meta_description: 'meta_description',
  meta_keywords: 'meta_keywords',
  shortTitle: 'shortTitle'
};

exports.Prisma.CollectionScalarFieldEnum = {
  id: 'id',
  handle: 'handle',
  visibility: 'visibility',
  imageUrl: 'imageUrl',
  imageAlt: 'imageAlt',
  msProductIds: 'msProductIds',
  shopify_id: 'shopify_id',
  published_at: 'published_at',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  related_collections: 'related_collections'
};

exports.Prisma.BrandAttbScalarFieldEnum = {
  id: 'id',
  brandId: 'brandId',
  loc: 'loc',
  displayName: 'displayName',
  description: 'description'
};

exports.Prisma.BrandScalarFieldEnum = {
  id: 'id',
  name: 'name',
  visibility: 'visibility',
  showInFilters: 'showInFilters',
  imageUrl: 'imageUrl',
  imageAlt: 'imageAlt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  collectionHandle: 'collectionHandle'
};

exports.Prisma.CategoryAttbScalarFieldEnum = {
  id: 'id',
  categoryId: 'categoryId',
  loc: 'loc',
  displayName: 'displayName',
  description: 'description'
};

exports.Prisma.CategoryScalarFieldEnum = {
  id: 'id',
  name: 'name',
  visibility: 'visibility',
  imageUrl: 'imageUrl',
  imageAlt: 'imageAlt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  collectionHandle: 'collectionHandle'
};

exports.Prisma.SubcategoryAttbScalarFieldEnum = {
  id: 'id',
  subCategoryId: 'subCategoryId',
  loc: 'loc',
  displayName: 'displayName',
  description: 'description'
};

exports.Prisma.SubcategoryScalarFieldEnum = {
  id: 'id',
  name: 'name',
  visibility: 'visibility',
  imageUrl: 'imageUrl',
  imageAlt: 'imageAlt',
  categoryName: 'categoryName',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  collectionHandle: 'collectionHandle'
};

exports.Prisma.TagScalarFieldEnum = {
  id: 'id',
  tagName: 'tagName',
  msProductIds: 'msProductIds',
  createdAt: 'createdAt'
};

exports.Prisma.MSProductAttbScalarFieldEnum = {
  id: 'id',
  msProductId: 'msProductId',
  loc: 'loc',
  displayName: 'displayName',
  description: 'description'
};

exports.Prisma.MSProductScalarFieldEnum = {
  id: 'id',
  handle: 'handle',
  variant_type: 'variant_type',
  priceFull: 'priceFull',
  priceTrial: 'priceTrial',
  priceVIP: 'priceVIP',
  priceVVIP: 'priceVVIP',
  comparePriceFull: 'comparePriceFull',
  comparePriceTrial: 'comparePriceTrial',
  comparePriceVIP: 'comparePriceVIP',
  comparePriceVVIP: 'comparePriceVVIP',
  sell_state: 'sell_state',
  averageRating: 'averageRating',
  isShowRating: 'isShowRating',
  stockQty: 'stockQty',
  imagesUrl: 'imagesUrl',
  imagesAlt: 'imagesAlt',
  featuredImageUrl: 'featuredImageUrl',
  tagIds: 'tagIds',
  tagsStr: 'tagsStr',
  publishedAt: 'publishedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  collectionIds: 'collectionIds',
  searchContent: 'searchContent',
  articleIds: 'articleIds',
  related_productIds: 'related_productIds',
  related_by_productIds: 'related_by_productIds',
  promotionIds: 'promotionIds',
  variantAttbPresets: 'variantAttbPresets',
  isDeleted: 'isDeleted',
  deletedAt: 'deletedAt'
};

exports.Prisma.MSProductVariantPresetScalarFieldEnum = {
  id: 'id',
  attb: 'attb',
  attbValue: 'attbValue',
  mSProductId: 'mSProductId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.MSProductDetailAttbScalarFieldEnum = {
  id: 'id',
  msProductDetailId: 'msProductDetailId',
  loc: 'loc',
  dimensions: 'dimensions',
  color: 'color',
  material: 'material',
  manufacturer: 'manufacturer',
  distributor: 'distributor',
  specs: 'specs',
  warranty: 'warranty',
  safetyInformation: 'safetyInformation',
  careInstructions: 'careInstructions',
  seoDescription: 'seoDescription',
  additionalDesc: 'additionalDesc',
  title: 'title',
  meta_title: 'meta_title',
  body_html: 'body_html',
  meta_description: 'meta_description',
  meta_keywords: 'meta_keywords',
  ingredient: 'ingredient',
  how_to_use: 'how_to_use',
  brand: 'brand',
  fda_value: 'fda_value',
  how_it_works: 'how_it_works',
  og: 'og',
  testimonial: 'testimonial',
  title_tag: 'title_tag',
  warning: 'warning',
  others: 'others'
};

exports.Prisma.MSProductDetailScalarFieldEnum = {
  id: 'id',
  msProductHandle: 'msProductHandle',
  weight: 'weight',
  is_auto_ship: 'is_auto_ship',
  free_ship: 'free_ship',
  enable_in_renew: 'enable_in_renew',
  renew_discount_amount: 'renew_discount_amount',
  inventory: 'inventory',
  QV: 'QV',
  CV: 'CV',
  QV_VIP: 'QV_VIP',
  CV_VIP: 'CV_VIP',
  QV_VVIP: 'QV_VVIP',
  CV_VVIP: 'CV_VVIP',
  product_id: 'product_id',
  log_id: 'log_id',
  period: 'period',
  enable_qr: 'enable_qr',
  enable_qr_banner: 'enable_qr_banner',
  product_type: 'product_type',
  seoKeywords: 'seoKeywords',
  associatedProducts: 'associatedProducts',
  related_articles: 'related_articles',
  related_products: 'related_products',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.MSProductVariantAttbScalarFieldEnum = {
  id: 'id',
  msProductVariantId: 'msProductVariantId',
  loc: 'loc',
  title: 'title',
  public_title: 'public_title',
  name: 'name',
  customPromoMessage: 'customPromoMessage',
  opttion1: 'opttion1',
  opttion2: 'opttion2',
  opttion3: 'opttion3',
  options: 'options'
};

exports.Prisma.MSProductVariantScalarFieldEnum = {
  id: 'id',
  msProductHandle: 'msProductHandle',
  position: 'position',
  SKU: 'SKU',
  pairSku: 'pairSku',
  variant_id: 'variant_id',
  variant_type: 'variant_type',
  enableInFrontEnd: 'enableInFrontEnd',
  enableInPromotion: 'enableInPromotion',
  enableSubscription: 'enableSubscription',
  enableSellButton: 'enableSellButton',
  published: 'published',
  available: 'available',
  requires_shipping: 'requires_shipping',
  taxable: 'taxable',
  priceFull: 'priceFull',
  priceTrial: 'priceTrial',
  priceVIP: 'priceVIP',
  priceVVIP: 'priceVVIP',
  comparePriceFull: 'comparePriceFull',
  comparePriceTrial: 'comparePriceTrial',
  comparePriceVIP: 'comparePriceVIP',
  comparePriceVVIP: 'comparePriceVVIP',
  QV: 'QV',
  CV: 'CV',
  QV_VIP: 'QV_VIP',
  CV_VIP: 'CV_VIP',
  QV_VVIP: 'QV_VVIP',
  CV_VVIP: 'CV_VVIP',
  weight: 'weight',
  is_auto_ship: 'is_auto_ship',
  free_ship: 'free_ship',
  enable_in_renew: 'enable_in_renew',
  renew_discount_amount: 'renew_discount_amount',
  inventory: 'inventory',
  inventory_used: 'inventory_used',
  product_id: 'product_id',
  log_id: 'log_id',
  period: 'period',
  enable_qr: 'enable_qr',
  enable_qr_banner: 'enable_qr_banner',
  product_type: 'product_type',
  barcode: 'barcode',
  inventory_management: 'inventory_management',
  featuredImageUrl: 'featuredImageUrl',
  imagesUrl: 'imagesUrl',
  quantity_rule_min: 'quantity_rule_min',
  quantity_rule_max: 'quantity_rule_max',
  quantity_rule_increment_step: 'quantity_rule_increment_step',
  show_after_promotion: 'show_after_promotion',
  show_during_promotion: 'show_during_promotion',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isDeleted: 'isDeleted',
  deletedAt: 'deletedAt'
};

exports.Prisma.MSProductScoreScalarFieldEnum = {
  id: 'id',
  score: 'score',
  numUserRate: 'numUserRate',
  msProductHandle: 'msProductHandle',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.MSProductUserRatingScalarFieldEnum = {
  id: 'id',
  score: 'score',
  message: 'message',
  userId: 'userId',
  msProductHandle: 'msProductHandle',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserFavProductScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  msProductHandle: 'msProductHandle',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SaleOrderScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  interfaceAX017LogId: 'interfaceAX017LogId',
  trackingReferenceNumber: 'trackingReferenceNumber',
  paymentMethod: 'paymentMethod',
  paymentMethodType: 'paymentMethodType',
  paymentMethodName: 'paymentMethodName',
  paymentRedirect: 'paymentRedirect',
  shipmentMethod: 'shipmentMethod',
  shipmentName: 'shipmentName',
  shipmentTrackingLink: 'shipmentTrackingLink',
  currencyCode: 'currencyCode',
  status: 'status',
  axStatus: 'axStatus',
  docNo: 'docNo',
  isAchieved: 'isAchieved',
  final_price: 'final_price',
  final_QV: 'final_QV',
  final_CV: 'final_CV',
  final_discount: 'final_discount',
  final_vatAmount: 'final_vatAmount',
  final_netAmount: 'final_netAmount',
  chargeAmount: 'chargeAmount',
  chargeCode: 'chargeCode',
  chargeVAT: 'chargeVAT',
  receiptAddress: 'receiptAddress',
  nationalId: 'nationalId',
  taxInvoiceAddress: 'taxInvoiceAddress',
  isTaxInvoice: 'isTaxInvoice',
  discounts: 'discounts',
  discountRemarks: 'discountRemarks',
  promoCode: 'promoCode',
  bonusCVs: 'bonusCVs',
  bonusCVRemarks: 'bonusCVRemarks',
  bonusQVs: 'bonusQVs',
  bonusQVRemarks: 'bonusQVRemarks',
  modeOfDelivery: 'modeOfDelivery',
  channel: 'channel',
  shipmentPrefix: 'shipmentPrefix',
  paidAt: 'paidAt',
  preferOrderingAt: 'preferOrderingAt',
  orderingAt: 'orderingAt',
  orderedAt: 'orderedAt',
  deliveringAt: 'deliveringAt',
  deliveredAt: 'deliveredAt',
  completedAt: 'completedAt',
  cancelingAt: 'cancelingAt',
  canceledAt: 'canceledAt',
  lastAxUpdateAt: 'lastAxUpdateAt',
  resendCounter: 'resendCounter',
  isStaffCreate: 'isStaffCreate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  slipUrl: 'slipUrl'
};

exports.Prisma.SaleItemScalarFieldEnum = {
  id: 'id',
  saleOrderId: 'saleOrderId',
  msProductHandle: 'msProductHandle',
  msProductVariantId: 'msProductVariantId',
  CV: 'CV',
  discount: 'discount',
  lineId: 'lineId',
  netAmount: 'netAmount',
  quantity: 'quantity',
  QV: 'QV',
  price: 'price',
  vatAmount: 'vatAmount',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.RunningNumberScalarFieldEnum = {
  id: 'id',
  prefix: 'prefix',
  number: 'number',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PaymentTransactionScalarFieldEnum = {
  id: 'id',
  merchantID: 'merchantID',
  invoiceNo: 'invoiceNo',
  amount: 'amount',
  currencyCode: 'currencyCode',
  transactionDateTime: 'transactionDateTime',
  agentCode: 'agentCode',
  channelCode: 'channelCode',
  approvalCode: 'approvalCode',
  referenceNo: 'referenceNo',
  tranRef: 'tranRef',
  accountNo: 'accountNo',
  customerToken: 'customerToken',
  customerTokenExpiry: 'customerTokenExpiry',
  cardType: 'cardType',
  issuerCountry: 'issuerCountry',
  issuerBank: 'issuerBank',
  eci: 'eci',
  installmentPeriod: 'installmentPeriod',
  interestType: 'interestType',
  interestRate: 'interestRate',
  installmentMerchantAbsorbRate: 'installmentMerchantAbsorbRate',
  recurringUniqueID: 'recurringUniqueID',
  recurringSequenceNo: 'recurringSequenceNo',
  fxAmount: 'fxAmount',
  fxRate: 'fxRate',
  fxCurrencyCode: 'fxCurrencyCode',
  userDefined1: 'userDefined1',
  userDefined2: 'userDefined2',
  userDefined3: 'userDefined3',
  userDefined4: 'userDefined4',
  userDefined5: 'userDefined5',
  acquirerReferenceNo: 'acquirerReferenceNo',
  acquirerMerchantId: 'acquirerMerchantId',
  idempotencyID: 'idempotencyID',
  paymentScheme: 'paymentScheme',
  paymentID: 'paymentID',
  schemePaymentID: 'schemePaymentID',
  acquirerResponseCode: 'acquirerResponseCode',
  respCode: 'respCode',
  respDesc: 'respDesc',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SaleOrderTimelineScalarFieldEnum = {
  id: 'id',
  type: 'type',
  saleOrderId: 'saleOrderId',
  auditorUserId: 'auditorUserId',
  timelineTitle: 'timelineTitle',
  timelineNote: 'timelineNote',
  oldData: 'oldData',
  newData: 'newData',
  createdAt: 'createdAt'
};

exports.Prisma.PagePathScalarFieldEnum = {
  id: 'id',
  platform: 'platform',
  path: 'path',
  name: 'name',
  pageLayoutId: 'pageLayoutId',
  meta_title: 'meta_title',
  meta_description: 'meta_description',
  meta_keywords: 'meta_keywords',
  og: 'og',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PageLayoutScalarFieldEnum = {
  id: 'id',
  name: 'name',
  layoutType: 'layoutType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.LayoutComponentScalarFieldEnum = {
  id: 'id',
  name: 'name',
  type: 'type',
  priority: 'priority',
  pageLayoutId: 'pageLayoutId',
  sticky: 'sticky',
  param1: 'param1',
  param2: 'param2',
  param3: 'param3',
  param4: 'param4',
  param5: 'param5',
  paramList1: 'paramList1',
  paramList2: 'paramList2',
  paramList3: 'paramList3',
  paramList4: 'paramList4',
  paramList5: 'paramList5',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SectionComponentOnPagePathScalarFieldEnum = {
  id: 'id',
  sectionComponentId: 'sectionComponentId',
  pagePathId: 'pagePathId',
  priority: 'priority'
};

exports.Prisma.SectionComponentScalarFieldEnum = {
  id: 'id',
  name: 'name',
  componentName: 'componentName',
  priority: 'priority',
  enable: 'enable',
  independent: 'independent',
  param1: 'param1',
  param2: 'param2',
  param3: 'param3',
  param4: 'param4',
  param5: 'param5',
  paramList1: 'paramList1',
  paramList2: 'paramList2',
  paramList3: 'paramList3',
  paramList4: 'paramList4',
  paramList5: 'paramList5',
  componentConfigId: 'componentConfigId',
  pagePathId: 'pagePathId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SectionComponentConfigScalarFieldEnum = {
  id: 'id',
  componentName: 'componentName',
  useParams: 'useParams',
  requiredParams: 'requiredParams',
  descParams: 'descParams',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AddressScalarFieldEnum = {
  id: 'id',
  addressName: 'addressName',
  receiver_name: 'receiver_name',
  receiver_surname: 'receiver_surname',
  receiver_tel: 'receiver_tel',
  note: 'note',
  postcode: 'postcode',
  cityId: 'cityId',
  stateId: 'stateId',
  cityEN: 'cityEN',
  stateEN: 'stateEN',
  countryEN: 'countryEN',
  cityTH: 'cityTH',
  stateTH: 'stateTH',
  countryTH: 'countryTH',
  address: 'address',
  stateCode: 'stateCode',
  isBilling: 'isBilling',
  isDeleted: 'isDeleted'
};

exports.Prisma.UserAddressScalarFieldEnum = {
  id: 'id',
  addressId: 'addressId',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CoApplicantAddressScalarFieldEnum = {
  id: 'id',
  addressId: 'addressId',
  userCoApplicantId: 'userCoApplicantId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.OrderAddressScalarFieldEnum = {
  id: 'id',
  addressId: 'addressId',
  saleOrderId: 'saleOrderId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BankScalarFieldEnum = {
  id: 'id',
  country: 'country',
  account_code: 'account_code',
  account_number_digit: 'account_number_digit',
  bank_code: 'bank_code',
  nameEN: 'nameEN',
  nameTH: 'nameTH',
  status: 'status'
};

exports.Prisma.WebFooterComponentScalarFieldEnum = {
  id: 'id',
  name: 'name',
  imageUrl: 'imageUrl',
  imageAlt: 'imageAlt',
  imagePosition: 'imagePosition',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.WebFooterSectionAttbScalarFieldEnum = {
  id: 'id',
  webFooterSectionId: 'webFooterSectionId',
  loc: 'loc',
  displayName: 'displayName',
  description: 'description'
};

exports.Prisma.WebFooterSectionScalarFieldEnum = {
  id: 'id',
  columnTitleDisplay: 'columnTitleDisplay',
  priority: 'priority',
  vType: 'vType',
  position: 'position',
  offsetTop: 'offsetTop',
  webFooterComponentId: 'webFooterComponentId'
};

exports.Prisma.WebFooterItemAttbScalarFieldEnum = {
  id: 'id',
  webFooterItemId: 'webFooterItemId',
  loc: 'loc',
  displayName: 'displayName',
  description: 'description',
  linkUrl: 'linkUrl'
};

exports.Prisma.WebFooterItemScalarFieldEnum = {
  id: 'id',
  type: 'type',
  priority: 'priority',
  linkTarget: 'linkTarget',
  icon: 'icon',
  webFooterSectionId: 'webFooterSectionId',
  itemSectionId: 'itemSectionId'
};

exports.Prisma.WebBannerComponentScalarFieldEnum = {
  id: 'id',
  name: 'name',
  sectionWidth: 'sectionWidth',
  contentWidth: 'contentWidth',
  autoSlide: 'autoSlide',
  slideDelay: 'slideDelay',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  size: 'size',
  paddingTop: 'paddingTop'
};

exports.Prisma.BannerItemAttbScalarFieldEnum = {
  id: 'id',
  bannerItemId: 'bannerItemId',
  loc: 'loc',
  desktopImageUrl: 'desktopImageUrl',
  mobileImageUrl: 'mobileImageUrl',
  imageAlt: 'imageAlt',
  linkUrl: 'linkUrl'
};

exports.Prisma.BannerItemScalarFieldEnum = {
  id: 'id',
  linkTarget: 'linkTarget',
  webBannerComponentId: 'webBannerComponentId'
};

exports.Prisma.WebTextLabelAttbScalarFieldEnum = {
  id: 'id',
  webTextLabelId: 'webTextLabelId',
  loc: 'loc',
  displayName: 'displayName',
  description: 'description',
  linkUrl: 'linkUrl'
};

exports.Prisma.WebTextLabelComponentScalarFieldEnum = {
  id: 'id',
  name: 'name',
  linkTarget: 'linkTarget',
  textAlign: 'textAlign',
  textColor: 'textColor',
  bgColor1: 'bgColor1',
  bgColor2: 'bgColor2',
  bgColor3: 'bgColor3',
  bgColor4: 'bgColor4',
  gradientAngle: 'gradientAngle',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.WebAdsSectionComponentScalarFieldEnum = {
  id: 'id',
  name: 'name',
  sectionWidth: 'sectionWidth',
  contentWidth: 'contentWidth',
  bgDesktopImageUrl: 'bgDesktopImageUrl',
  bgMobileImageUrl: 'bgMobileImageUrl',
  bgColor1: 'bgColor1',
  bgColor2: 'bgColor2',
  bgColor3: 'bgColor3',
  bgColor4: 'bgColor4',
  gradientAngle: 'gradientAngle',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.WebAdsSectionScalarFieldEnum = {
  id: 'id',
  priority: 'priority',
  cols: 'cols',
  webAdsSectionComponentId: 'webAdsSectionComponentId'
};

exports.Prisma.WebAdsSectionLayoutScalarFieldEnum = {
  id: 'id',
  priority: 'priority',
  webAdsSectionId: 'webAdsSectionId'
};

exports.Prisma.WebAdsItemContentAttbScalarFieldEnum = {
  id: 'id',
  webAdsItemContentId: 'webAdsItemContentId',
  loc: 'loc',
  displayName: 'displayName',
  description: 'description',
  linkUrl: 'linkUrl'
};

exports.Prisma.WebAdsItemContentScalarFieldEnum = {
  id: 'id',
  contentType: 'contentType',
  priority: 'priority',
  webAdsSectionLayoutId: 'webAdsSectionLayoutId',
  dispHTMLTag: 'dispHTMLTag',
  dispSize: 'dispSize',
  dispWeight: 'dispWeight',
  dispColor1: 'dispColor1',
  dispColor2: 'dispColor2',
  dispColor3: 'dispColor3',
  dispColor4: 'dispColor4',
  dispGradientAngle: 'dispGradientAngle',
  descHTMLTag: 'descHTMLTag',
  descSize: 'descSize',
  descWeight: 'descWeight',
  descColor1: 'descColor1',
  descColor2: 'descColor2',
  descColor3: 'descColor3',
  descColor4: 'descColor4',
  descGradientAngle: 'descGradientAngle',
  buttonTextColor: 'buttonTextColor',
  buttonBorder: 'buttonBorder',
  buttonBorderColor: 'buttonBorderColor',
  buttonBgColor1: 'buttonBgColor1',
  buttonBgColor2: 'buttonBgColor2',
  buttonBgColor3: 'buttonBgColor3',
  buttonBgColor4: 'buttonBgColor4',
  buttonGradientAngle: 'buttonGradientAngle',
  linkTarget: 'linkTarget',
  contentAlign: 'contentAlign'
};

exports.Prisma.WebAdsItemIconAttbScalarFieldEnum = {
  id: 'id',
  webAdsItemIconId: 'webAdsItemIconId',
  loc: 'loc',
  displayName: 'displayName',
  description: 'description',
  desktopImageUrl: 'desktopImageUrl',
  mobileImageUrl: 'mobileImageUrl',
  imageAlt: 'imageAlt',
  linkUrl: 'linkUrl'
};

exports.Prisma.WebAdsItemIconScalarFieldEnum = {
  id: 'id',
  priority: 'priority',
  linkTarget: 'linkTarget',
  webAdsItemContentId: 'webAdsItemContentId'
};

exports.Prisma.WebShortCutAttbScalarFieldEnum = {
  id: 'id',
  webShortCutId: 'webShortCutId',
  loc: 'loc',
  displayName: 'displayName',
  description: 'description'
};

exports.Prisma.WebShortCutComponentScalarFieldEnum = {
  id: 'id',
  type: 'type',
  name: 'name',
  sectionWidth: 'sectionWidth',
  contentWidth: 'contentWidth',
  paramList1: 'paramList1',
  isOverflow: 'isOverflow',
  bgColor1: 'bgColor1',
  bgColor2: 'bgColor2',
  bgColor3: 'bgColor3',
  bgColor4: 'bgColor4',
  gradientAngle: 'gradientAngle',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ShortCutItemAttbScalarFieldEnum = {
  id: 'id',
  shortCutItemId: 'shortCutItemId',
  loc: 'loc',
  imageUrl: 'imageUrl',
  imageAlt: 'imageAlt',
  displayName: 'displayName',
  description: 'description',
  linkUrl: 'linkUrl',
  buttonName: 'buttonName'
};

exports.Prisma.ShortCutItemScalarFieldEnum = {
  id: 'id',
  priority: 'priority',
  linkTarget: 'linkTarget',
  dispSize: 'dispSize',
  dispWeight: 'dispWeight',
  dispColor1: 'dispColor1',
  dispColor2: 'dispColor2',
  dispColor3: 'dispColor3',
  dispColor4: 'dispColor4',
  dispGradientAngle: 'dispGradientAngle',
  dispMaxLine: 'dispMaxLine',
  descSize: 'descSize',
  descWeight: 'descWeight',
  descColor1: 'descColor1',
  descColor2: 'descColor2',
  descColor3: 'descColor3',
  descColor4: 'descColor4',
  descGradientAngle: 'descGradientAngle',
  descMaxLine: 'descMaxLine',
  conditionId: 'conditionId',
  webShortCutComponentId: 'webShortCutComponentId'
};

exports.Prisma.WebMediaAdsComponentScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.WebMediaAdsItemScalarFieldEnum = {
  id: 'id',
  priority: 'priority',
  dataType: 'dataType',
  dataId: 'dataId',
  mediaType: 'mediaType',
  mediaUrl: 'mediaUrl',
  webMediaAdsId: 'webMediaAdsId'
};

exports.Prisma.WebNavigationComponentScalarFieldEnum = {
  id: 'id',
  template: 'template',
  name: 'name',
  position: 'position',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.NavigationMenuAttbScalarFieldEnum = {
  id: 'id',
  navigationMenuId: 'navigationMenuId',
  loc: 'loc',
  displayName: 'displayName',
  linkUrl: 'linkUrl',
  imageUrl: 'imageUrl',
  imageAlt: 'imageAlt'
};

exports.Prisma.NavigationMenuScalarFieldEnum = {
  id: 'id',
  type: 'type',
  routeType: 'routeType',
  priority: 'priority',
  linkTarget: 'linkTarget',
  menuIcon: 'menuIcon',
  param1: 'param1',
  param2: 'param2',
  param3: 'param3',
  param4: 'param4',
  param5: 'param5',
  paramList1: 'paramList1',
  paramList2: 'paramList2',
  paramList3: 'paramList3',
  paramList4: 'paramList4',
  paramList5: 'paramList5',
  webNavigationComponentId: 'webNavigationComponentId',
  navigationMenuId: 'navigationMenuId'
};

exports.Prisma.ItemComponentConditionScalarFieldEnum = {
  id: 'id',
  showWhenLoginOnly: 'showWhenLoginOnly',
  actionFunc: 'actionFunc',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ContentAtbScalarFieldEnum = {
  id: 'id',
  loc: 'loc',
  contentName: 'contentName',
  data: 'data',
  dataList: 'dataList',
  link: 'link',
  alt: 'alt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ContentScalarFieldEnum = {
  id: 'id',
  contentName: 'contentName',
  type: 'type',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ArticleCategoryAttbScalarFieldEnum = {
  id: 'id',
  categoryHandle: 'categoryHandle',
  loc: 'loc',
  displayName: 'displayName',
  description: 'description',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ArticleCategoryScalarFieldEnum = {
  id: 'id',
  handle: 'handle',
  articleIds: 'articleIds',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ArticleTagScalarFieldEnum = {
  id: 'id',
  name: 'name',
  articleIds: 'articleIds',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ArticleAtbScalarFieldEnum = {
  id: 'id',
  loc: 'loc',
  articleHandle: 'articleHandle',
  title: 'title',
  body_html: 'body_html',
  summary_html: 'summary_html',
  meta_title: 'meta_title',
  meta_description: 'meta_description',
  meta_keywords: 'meta_keywords',
  excerpt: 'excerpt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ArticleScalarFieldEnum = {
  id: 'id',
  handle: 'handle',
  enable: 'enable',
  publishedAt: 'publishedAt',
  imageUrl: 'imageUrl',
  imageAlt: 'imageAlt',
  tagIds: 'tagIds',
  tagsString: 'tagsString',
  categoryIds: 'categoryIds',
  categoriesString: 'categoriesString',
  msProductIds: 'msProductIds',
  searchContent: 'searchContent',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ContactUsFormScalarFieldEnum = {
  id: 'id',
  name: 'name',
  tel: 'tel',
  email: 'email',
  message: 'message',
  status: 'status',
  staffNote: 'staffNote',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.FaqComponentAttbScalarFieldEnum = {
  id: 'id',
  faqComponentId: 'faqComponentId',
  loc: 'loc',
  displayName: 'displayName'
};

exports.Prisma.FaqComponentScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.FaqMenuAttbScalarFieldEnum = {
  id: 'id',
  faqMenuId: 'faqMenuId',
  loc: 'loc',
  displayName: 'displayName'
};

exports.Prisma.FaqMenuScalarFieldEnum = {
  id: 'id',
  faqComponentId: 'faqComponentId',
  handle: 'handle',
  priority: 'priority'
};

exports.Prisma.FaqItemAttbScalarFieldEnum = {
  id: 'id',
  faqItemId: 'faqItemId',
  loc: 'loc',
  displayName: 'displayName',
  description: 'description'
};

exports.Prisma.FaqItemScalarFieldEnum = {
  id: 'id',
  faqMenuId: 'faqMenuId',
  priority: 'priority'
};

exports.Prisma.CalendarAttbScalarFieldEnum = {
  id: 'id',
  calendarComponentId: 'calendarComponentId',
  loc: 'loc',
  displayName: 'displayName'
};

exports.Prisma.CalendarComponentScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EventScheduleAttbScalarFieldEnum = {
  id: 'id',
  eventScheduleId: 'eventScheduleId',
  loc: 'loc',
  displayName: 'displayName',
  description: 'description',
  desktopImageUrl: 'desktopImageUrl',
  mobileImageUrl: 'mobileImageUrl',
  imageBackgroundColor: 'imageBackgroundColor',
  imageAlt: 'imageAlt',
  location: 'location',
  introList: 'introList'
};

exports.Prisma.EventScheduleScalarFieldEnum = {
  id: 'id',
  startDateTime: 'startDateTime',
  endDateTime: 'endDateTime',
  enable: 'enable',
  calendarComponentId: 'calendarComponentId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SystemConfigScalarFieldEnum = {
  id: 'id',
  handle: 'handle',
  name: 'name',
  enabled: 'enabled',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ContentLanguageConfigScalarFieldEnum = {
  id: 'id',
  systemConfigId: 'systemConfigId',
  name: 'name',
  priority: 'priority',
  title: 'title',
  flag: 'flag',
  enable: 'enable',
  updatedAt: 'updatedAt'
};

exports.Prisma.SystemInterfaceConfigScalarFieldEnum = {
  id: 'id',
  interfaceName: 'interfaceName',
  interfaceFrom: 'interfaceFrom',
  enableSync: 'enableSync',
  systemConfigId: 'systemConfigId',
  updatedAt: 'updatedAt'
};

exports.Prisma.SystemSiteSettingConfigScalarFieldEnum = {
  id: 'id',
  systemConfigId: 'systemConfigId',
  maMode: 'maMode',
  defaultLanguage: 'defaultLanguage',
  enabledPurchase: 'enabledPurchase',
  disableRightClick: 'disableRightClick',
  updatedAt: 'updatedAt'
};

exports.Prisma.SystemAccountingConfigScalarFieldEnum = {
  id: 'id',
  systemConfigId: 'systemConfigId',
  enableRegister: 'enableRegister',
  enableLogin: 'enableLogin',
  enableGoogleAuth: 'enableGoogleAuth',
  enableLineAuth: 'enableLineAuth',
  enableFacebookAuth: 'enableFacebookAuth',
  enableVerifyEmail: 'enableVerifyEmail',
  updatedAt: 'updatedAt'
};

exports.Prisma.SystemContactConfigScalarFieldEnum = {
  id: 'id',
  systemConfigId: 'systemConfigId',
  email: 'email',
  telephone: 'telephone',
  updatedAt: 'updatedAt'
};

exports.Prisma.WebStepInformationComponentScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.WebStepAttbScalarFieldEnum = {
  id: 'id',
  webStepId: 'webStepId',
  loc: 'loc',
  displayName: 'displayName',
  displayNameMobile: 'displayNameMobile'
};

exports.Prisma.WebStepScalarFieldEnum = {
  id: 'id',
  priority: 'priority',
  webStepInformationComponentId: 'webStepInformationComponentId'
};

exports.Prisma.WebStepItemAttbScalarFieldEnum = {
  id: 'id',
  webStepItemId: 'webStepItemId',
  loc: 'loc',
  displayName: 'displayName',
  description: 'description'
};

exports.Prisma.WebStepItemScalarFieldEnum = {
  id: 'id',
  priority: 'priority',
  webStepId: 'webStepId'
};

exports.Prisma.WebInformationAttbScalarFieldEnum = {
  id: 'id',
  webInformationId: 'webInformationId',
  loc: 'loc',
  displayName: 'displayName',
  description: 'description'
};

exports.Prisma.WebInformationScalarFieldEnum = {
  id: 'id',
  webStepInformationComponentId: 'webStepInformationComponentId',
  priority: 'priority'
};

exports.Prisma.NotificationActionScalarFieldEnum = {
  id: 'id',
  action: 'action',
  name: 'name',
  enable: 'enable',
  description: 'description',
  inAppEnable: 'inAppEnable',
  inAppNotifyTemplateId: 'inAppNotifyTemplateId',
  smsEnable: 'smsEnable',
  smsTemplateId: 'smsTemplateId',
  emailEnable: 'emailEnable',
  emailTemplateId: 'emailTemplateId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.NotificationScheduleScalarFieldEnum = {
  id: 'id',
  jobExpressionType: 'jobExpressionType',
  jobName: 'jobName',
  jobDescription: 'jobDescription',
  enable: 'enable',
  setSecound: 'setSecound',
  setMinute: 'setMinute',
  setHourStart: 'setHourStart',
  setHourEnd: 'setHourEnd',
  setDayOfWeek: 'setDayOfWeek',
  setDateOfMonth: 'setDateOfMonth',
  setMonth: 'setMonth',
  cronExpression: 'cronExpression',
  effectiveAt: 'effectiveAt',
  effectiveUntil: 'effectiveUntil',
  lastPublished: 'lastPublished',
  lastExecution: 'lastExecution',
  registered: 'registered',
  executionLimit: 'executionLimit',
  executionCount: 'executionCount',
  customerLevel: 'customerLevel',
  userList: 'userList',
  inAppEnable: 'inAppEnable',
  inAppNotifyTemplateId: 'inAppNotifyTemplateId',
  smsEnable: 'smsEnable',
  smsTemplateId: 'smsTemplateId',
  emailEnable: 'emailEnable',
  emailTemplateId: 'emailTemplateId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.NotificationExecutionLogScalarFieldEnum = {
  id: 'id',
  jobName: 'jobName',
  state: 'state',
  jobData: 'jobData',
  failMessage: 'failMessage',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserNotificationScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  inAppNotifyId: 'inAppNotifyId',
  link: 'link',
  linkTarget: 'linkTarget',
  notificationBody: 'notificationBody',
  readStatus: 'readStatus',
  publishAt: 'publishAt',
  paramData: 'paramData',
  expiredAt: 'expiredAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.InAppNotifyTemplateAttbScalarFieldEnum = {
  id: 'id',
  loc: 'loc',
  displayName: 'displayName',
  description: 'description',
  imageUrl: 'imageUrl',
  linkUrl: 'linkUrl',
  linkTarget: 'linkTarget',
  inAppNotifyTemplateId: 'inAppNotifyTemplateId'
};

exports.Prisma.InAppNotifyTemplateScalarFieldEnum = {
  id: 'id',
  name: 'name',
  paramData: 'paramData',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SMSTemplateAttbScalarFieldEnum = {
  id: 'id',
  loc: 'loc',
  displayName: 'displayName',
  description: 'description',
  smsTemplateId: 'smsTemplateId'
};

exports.Prisma.SMSTemplateScalarFieldEnum = {
  id: 'id',
  name: 'name',
  paramData: 'paramData',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EmailTemplateAttbScalarFieldEnum = {
  id: 'id',
  loc: 'loc',
  displayName: 'displayName',
  description: 'description',
  emailTemplateId: 'emailTemplateId'
};

exports.Prisma.EmailTemplateScalarFieldEnum = {
  id: 'id',
  name: 'name',
  paramData: 'paramData',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.NotificationCronJobExecutionScalarFieldEnum = {
  id: 'id',
  jobName: 'jobName',
  jobStatus: 'jobStatus',
  jobCommand: 'jobCommand',
  commandLists: 'commandLists',
  running: 'running',
  pendingCount: 'pendingCount',
  successCount: 'successCount',
  failedCount: 'failedCount',
  skipCount: 'skipCount',
  isAchieved: 'isAchieved',
  runAt: 'runAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AboutUlifePromoteComponentScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AboutUlifePromoteAttbScalarFieldEnum = {
  id: 'id',
  loc: 'loc',
  name: 'name',
  displayName: 'displayName',
  description: 'description',
  aboutUlifePromoteComponentId: 'aboutUlifePromoteComponentId'
};

exports.Prisma.AboutUlifePromoteElementScalarFieldEnum = {
  id: 'id',
  name: 'name',
  priority: 'priority',
  aboutUlifePromoteComponentId: 'aboutUlifePromoteComponentId'
};

exports.Prisma.AboutUlifePromoteElementAttbScalarFieldEnum = {
  id: 'id',
  loc: 'loc',
  title: 'title',
  description: 'description',
  imageUrl: 'imageUrl',
  imageAlt: 'imageAlt',
  aboutUlifePromoteElementId: 'aboutUlifePromoteElementId'
};

exports.Prisma.GridCardComponentScalarFieldEnum = {
  id: 'id',
  name: 'name',
  enable: 'enable',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.GridCardElementScalarFieldEnum = {
  id: 'id',
  enable: 'enable',
  priority: 'priority',
  enableDialogDetail: 'enableDialogDetail',
  gridCardComponentId: 'gridCardComponentId'
};

exports.Prisma.GridCardAttbScalarFieldEnum = {
  id: 'id',
  loc: 'loc',
  cardTitle: 'cardTitle',
  cardDescription: 'cardDescription',
  cardFooter: 'cardFooter',
  cardImageUrl: 'cardImageUrl',
  cardImageAlt: 'cardImageAlt',
  cardPaddingTop: 'cardPaddingTop',
  dialogTitle: 'dialogTitle',
  dialogSubtitle: 'dialogSubtitle',
  dialogDescription: 'dialogDescription',
  dialogImageUrl: 'dialogImageUrl',
  dialogImageAlt: 'dialogImageAlt',
  dialogBgColor1: 'dialogBgColor1',
  dialogBgColor2: 'dialogBgColor2',
  dialogBgColor3: 'dialogBgColor3',
  dialogBgColor4: 'dialogBgColor4',
  dialogGradientAngle: 'dialogGradientAngle',
  gridCardElementId: 'gridCardElementId'
};

exports.Prisma.HorizontalCardComponentScalarFieldEnum = {
  id: 'id',
  name: 'name',
  enable: 'enable',
  sectionWidth: 'sectionWidth',
  contentWidth: 'contentWidth',
  bgColor1: 'bgColor1',
  bgColor2: 'bgColor2',
  bgColor3: 'bgColor3',
  bgColor4: 'bgColor4',
  gradientAngle: 'gradientAngle',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.HorizontalCardElementScalarFieldEnum = {
  id: 'id',
  cardType: 'cardType',
  enable: 'enable',
  priority: 'priority',
  linkUrl: 'linkUrl',
  linkTarget: 'linkTarget',
  horizontalCardComponentId: 'horizontalCardComponentId'
};

exports.Prisma.HorizontalCardElementAttbScalarFieldEnum = {
  id: 'id',
  loc: 'loc',
  cardTitle: 'cardTitle',
  cardDescription: 'cardDescription',
  cardFooter: 'cardFooter',
  cardImageUrl: 'cardImageUrl',
  cardImageAlt: 'cardImageAlt',
  cardPaddingTop: 'cardPaddingTop',
  horizontalCardElementId: 'horizontalCardElementId'
};

exports.Prisma.GalleryComponentScalarFieldEnum = {
  id: 'id',
  name: 'name',
  enable: 'enable',
  embedUrl: 'embedUrl',
  titleColor: 'titleColor',
  desColor: 'desColor',
  desktopImageUrl: 'desktopImageUrl',
  mobileImageUrl: 'mobileImageUrl',
  imageAlt: 'imageAlt',
  images: 'images',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.GalleryComponentAttbScalarFieldEnum = {
  id: 'id',
  loc: 'loc',
  title: 'title',
  description: 'description',
  galleryComponentId: 'galleryComponentId'
};

exports.Prisma.AssetManagerScalarFieldEnum = {
  id: 'id',
  name: 'name',
  src: 'src',
  fileName: 'fileName',
  extension: 'extension',
  mineType: 'mineType',
  size: 'size',
  height: 'height',
  width: 'width',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.OneTimePasswordScalarFieldEnum = {
  id: 'id',
  isUsed: 'isUsed',
  useCase: 'useCase',
  code: 'code',
  refCode: 'refCode',
  expiresAt: 'expiresAt',
  ownerRef: 'ownerRef',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.FormScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.FormFieldScalarFieldEnum = {
  id: 'id',
  name: 'name',
  label: 'label',
  type: 'type',
  required: 'required',
  placeholder: 'placeholder',
  options: 'options',
  displayOrder: 'displayOrder',
  formId: 'formId',
  consentType: 'consentType',
  isChild: 'isChild',
  linkedOptions: 'linkedOptions',
  parentField: 'parentField',
  key: 'key',
  multipleFile: 'multipleFile',
  limitFile: 'limitFile'
};

exports.Prisma.FormSubmissionScalarFieldEnum = {
  id: 'id',
  formId: 'formId',
  submissionData: 'submissionData',
  trackingData: 'trackingData',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ShippingProfileScalarFieldEnum = {
  id: 'id',
  name: 'name',
  isActive: 'isActive',
  type: 'type',
  country: 'country',
  state: 'state',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ShippingMethodScalarFieldEnum = {
  id: 'id',
  method: 'method',
  price: 'price',
  isActive: 'isActive',
  position: 'position',
  shippingProfileId: 'shippingProfileId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ShippingMethodTranslationScalarFieldEnum = {
  id: 'id',
  shippingMethodId: 'shippingMethodId',
  locale: 'locale',
  name: 'name',
  deliveryTime: 'deliveryTime',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CodeAndScriptScalarFieldEnum = {
  id: 'id',
  headerHtml: 'headerHtml',
  afterStartBodyHtml: 'afterStartBodyHtml',
  beforeEndBodyHtml: 'beforeEndBodyHtml'
};

exports.Prisma.ShopCurrencyScalarFieldEnum = {
  id: 'id',
  currency: 'currency',
  symbol: 'symbol',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ShopCurrencyAttbScalarFieldEnum = {
  id: 'id',
  shopCurrencyId: 'shopCurrencyId',
  loc: 'loc',
  display: 'display',
  displayPosition: 'displayPosition'
};

exports.Prisma.PaymentMethodScalarFieldEnum = {
  id: 'id',
  handle: 'handle',
  type: 'type',
  method: 'method',
  merchantId: 'merchantId',
  secretKey: 'secretKey',
  requiredEvidence: 'requiredEvidence',
  enabled: 'enabled',
  default: 'default',
  priority: 'priority',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PaymentAttributeScalarFieldEnum = {
  id: 'id',
  loc: 'loc',
  title: 'title',
  paymentMethodId: 'paymentMethodId'
};

exports.Prisma.GeneralStylesScalarFieldEnum = {
  id: 'id',
  headerLogoUrl: 'headerLogoUrl',
  headerLogoAlt: 'headerLogoAlt',
  faviconIcoUrl: 'faviconIcoUrl',
  favicon16Url: 'favicon16Url',
  favicon32Url: 'favicon32Url',
  favicon48Url: 'favicon48Url',
  favicon64Url: 'favicon64Url',
  appleTouchIconUrl: 'appleTouchIconUrl',
  androidChromeIconUrl: 'androidChromeIconUrl',
  faviconAlt: 'faviconAlt',
  font: 'font',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SectionColorScalarFieldEnum = {
  id: 'id',
  sectionKey: 'sectionKey',
  colorCode: 'colorCode',
  defaultColorCode: 'defaultColorCode',
  updatedAt: 'updatedAt'
};

exports.Prisma.HeaderComponentScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.HeaderSectionScalarFieldEnum = {
  id: 'id',
  name: 'name',
  priority: 'priority',
  topPadding: 'topPadding',
  headerComponentId: 'headerComponentId'
};

exports.Prisma.HeaderSectionItemScalarFieldEnum = {
  id: 'id',
  name: 'name',
  priority: 'priority',
  orientations: 'orientations',
  position: 'position',
  topPadding: 'topPadding',
  headerSectionId: 'headerSectionId'
};

exports.Prisma.HeaderItemScalarFieldEnum = {
  id: 'id',
  priority: 'priority',
  type: 'type',
  linkTarget: 'linkTarget',
  menuComponentId: 'menuComponentId',
  headerSectionItemId: 'headerSectionItemId'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};
exports.API_INTERFACE_RESULT = exports.$Enums.API_INTERFACE_RESULT = {
  CALLED: 'CALLED',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED'
};

exports.API_INTERFACE_CUSTOMER_TIER_RESULT = exports.$Enums.API_INTERFACE_CUSTOMER_TIER_RESULT = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED'
};

exports.API_INTERFACE_AX017_RESULT = exports.$Enums.API_INTERFACE_AX017_RESULT = {
  READING: 'READING',
  SUCCESS: 'SUCCESS',
  ARCHIVED: 'ARCHIVED',
  FAILED: 'FAILED'
};

exports.CUSTOMER_LEVEL = exports.$Enums.CUSTOMER_LEVEL = {
  GUEST: 'GUEST',
  NORMAL: 'NORMAL',
  BF: 'BF',
  BP: 'BP',
  BP_VIP: 'BP_VIP',
  BP_VVIP: 'BP_VVIP'
};

exports.GENDER = exports.$Enums.GENDER = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  NOT_SPECIFIED: 'NOT_SPECIFIED'
};

exports.USER_TIMELINE_TYPE = exports.$Enums.USER_TIMELINE_TYPE = {
  ACCOUNT_CREATE: 'ACCOUNT_CREATE',
  STAFF_CREATE_ACCOUNT: 'STAFF_CREATE_ACCOUNT',
  STAFF_UPDATE_ACCOUNT: 'STAFF_UPDATE_ACCOUNT',
  STAFF_ADD_ADDRESS: 'STAFF_ADD_ADDRESS',
  STAFF_UPDATE_ADDRESS: 'STAFF_UPDATE_ADDRESS',
  STAFF_CHANGE_ADDRESS: 'STAFF_CHANGE_ADDRESS'
};

exports.STAFF_STATUS = exports.$Enums.STAFF_STATUS = {
  ACTIVE: 'ACTIVE',
  INVITED: 'INVITED'
};

exports.PERMISSION_ACTION = exports.$Enums.PERMISSION_ACTION = {
  MANAGE: 'MANAGE',
  LIST: 'LIST',
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  VIEW: 'VIEW',
  CUSTOM: 'CUSTOM',
  ALL_EXCEPT_MANAGE: 'ALL_EXCEPT_MANAGE',
  ALL: 'ALL'
};

exports.LOCALIZATION = exports.$Enums.LOCALIZATION = {
  EN: 'EN',
  TH: 'TH'
};

exports.PRODUCT_SELL_STATE = exports.$Enums.PRODUCT_SELL_STATE = {
  READY_FOR_SELL: 'READY_FOR_SELL',
  COMING_SOON: 'COMING_SOON',
  SOLD_OUT: 'SOLD_OUT',
  NOT_AVAILABLE: 'NOT_AVAILABLE'
};

exports.SALEORDER_PAYMENT = exports.$Enums.SALEORDER_PAYMENT = {
  COD: 'COD',
  TWOC2P: 'TWOC2P',
  NONE: 'NONE',
  TRANSFER: 'TRANSFER'
};

exports.PaymentMethodType = exports.$Enums.PaymentMethodType = {
  CREDIT_CARD: 'CREDIT_CARD',
  TRANSFER: 'TRANSFER',
  QR_PAYMENT: 'QR_PAYMENT',
  NONE: 'NONE',
  COD: 'COD'
};

exports.SALEORDER_SHIPMENT = exports.$Enums.SALEORDER_SHIPMENT = {
  TNT: 'TNT',
  DHL: 'DHL',
  OTHER: 'OTHER',
  free_shipping: 'free_shipping',
  flat_rate: 'flat_rate'
};

exports.SALEORDER_STATUS = exports.$Enums.SALEORDER_STATUS = {
  IN_CART: 'IN_CART',
  IN_CART_CALCULATED: 'IN_CART_CALCULATED',
  WAIT_PAYMENT: 'WAIT_PAYMENT',
  PAID: 'PAID',
  ORDERING: 'ORDERING',
  ORDERED: 'ORDERED',
  ORDERED_FAIL: 'ORDERED_FAIL',
  DELIVERING: 'DELIVERING',
  DELIVERED: 'DELIVERED',
  CANCELED: 'CANCELED',
  DELETING: 'DELETING',
  DELETED: 'DELETED',
  RESENDING: 'RESENDING',
  RESEND: 'RESEND'
};

exports.SALEORDER_AX_STATUS = exports.$Enums.SALEORDER_AX_STATUS = {
  Open: 'Open',
  Delivered: 'Delivered',
  Invoiced: 'Invoiced',
  Canceled: 'Canceled',
  Other: 'Other'
};

exports.SALEORDER_TIMELINE_TYPE = exports.$Enums.SALEORDER_TIMELINE_TYPE = {
  CUSTOMER_CART_CREATE: 'CUSTOMER_CART_CREATE',
  CUSTOMER_ADD_CART_ITEM: 'CUSTOMER_ADD_CART_ITEM',
  CUSTOMER_REMOVE_CART_ITEM: 'CUSTOMER_REMOVE_CART_ITEM',
  CUSTOMER_ADJUST_ITEM_QAUNTITY: 'CUSTOMER_ADJUST_ITEM_QAUNTITY',
  CUSTOMER_DESTROY_CART: 'CUSTOMER_DESTROY_CART',
  CUSTOMER_CHANGE_DELIVERY_ADDRESS: 'CUSTOMER_CHANGE_DELIVERY_ADDRESS',
  CUSTOMER_UPLOAD_SLIP: 'CUSTOMER_UPLOAD_SLIP',
  STAFF_CHANGE_DELIVERY_ADDRESS: 'STAFF_CHANGE_DELIVERY_ADDRESS',
  STAFF_CHANGE_STATUS: 'STAFF_CHANGE_STATUS',
  STAFF_CREATE_DRAFT: 'STAFF_CREATE_DRAFT',
  STAFF_ADD_CART_ITEM: 'STAFF_ADD_CART_ITEM',
  STAFF_REMOVE_CART_ITEM: 'STAFF_REMOVE_CART_ITEM',
  STAFF_ADJUST_ITEM_QAUNTITY: 'STAFF_ADJUST_ITEM_QAUNTITY',
  STAFF_DESTROY_CART: 'STAFF_DESTROY_CART',
  STAFF_RESEND_ORDER: 'STAFF_RESEND_ORDER',
  STAFF_ADD_NOTE: 'STAFF_ADD_NOTE',
  AX_OPEN: 'AX_OPEN',
  AX_Delivered: 'AX_Delivered',
  AX_Invoiced: 'AX_Invoiced',
  AX_Canceled: 'AX_Canceled',
  PAYMENT_2C2P_ACCEPTED: 'PAYMENT_2C2P_ACCEPTED',
  PAYMENT_COD_ACCEPTED: 'PAYMENT_COD_ACCEPTED',
  DELIVERY_CREATE: 'DELIVERY_CREATE'
};

exports.banks_status = exports.$Enums.banks_status = {
  Visible: 'Visible',
  Invisible: 'Invisible'
};

exports.FooterItemType = exports.$Enums.FooterItemType = {
  TEXT: 'TEXT',
  TEXT_WITH_ICON: 'TEXT_WITH_ICON',
  ICON: 'ICON',
  SECTION: 'SECTION'
};

exports.LinkTarget = exports.$Enums.LinkTarget = {
  SELF: 'SELF',
  BLANK: 'BLANK',
  PARENT: 'PARENT',
  TOP: 'TOP'
};

exports.ComponentSectionWidth = exports.$Enums.ComponentSectionWidth = {
  CONTAINER: 'CONTAINER',
  FLUID: 'FLUID'
};

exports.WebAdsItemContentType = exports.$Enums.WebAdsItemContentType = {
  TEXT: 'TEXT',
  ICON: 'ICON',
  BUTTON: 'BUTTON'
};

exports.WebHTMLTag = exports.$Enums.WebHTMLTag = {
  HEADER_1: 'HEADER_1',
  HEADER_2: 'HEADER_2',
  HEADER_3: 'HEADER_3',
  HEADER_4: 'HEADER_4',
  HEADER_5: 'HEADER_5',
  HEADER_6: 'HEADER_6',
  PARAGRAPH: 'PARAGRAPH'
};

exports.WebFontSize = exports.$Enums.WebFontSize = {
  H0: 'H0',
  H1: 'H1',
  H2: 'H2',
  H3: 'H3',
  H4: 'H4',
  H5: 'H5',
  H6: 'H6',
  H7: 'H7'
};

exports.WebFontWeight = exports.$Enums.WebFontWeight = {
  LIGHT: 'LIGHT',
  REGULAR: 'REGULAR',
  MEDIUM: 'MEDIUM',
  SEMIBOLD: 'SEMIBOLD',
  BOLD: 'BOLD'
};

exports.ContentAlignment = exports.$Enums.ContentAlignment = {
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
  CENTER: 'CENTER'
};

exports.WebShortCutType = exports.$Enums.WebShortCutType = {
  CATEGOTY: 'CATEGOTY',
  BRAND: 'BRAND',
  CUSTOM: 'CUSTOM',
  CUSTOM_CARD: 'CUSTOM_CARD'
};

exports.MediaAdsItemDataType = exports.$Enums.MediaAdsItemDataType = {
  PRODUCT: 'PRODUCT',
  PRODUCT_VARIANT: 'PRODUCT_VARIANT'
};

exports.MediaType = exports.$Enums.MediaType = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  EMBED: 'EMBED'
};

exports.NavigationMenuType = exports.$Enums.NavigationMenuType = {
  TEXT: 'TEXT',
  ICON: 'ICON',
  MASTER: 'MASTER'
};

exports.NavigationRouteType = exports.$Enums.NavigationRouteType = {
  CUSTOM: 'CUSTOM',
  PRODUCT: 'PRODUCT',
  COLLECTION: 'COLLECTION',
  CATEGORY: 'CATEGORY',
  BRAND: 'BRAND',
  TAG: 'TAG',
  ARTICLE: 'ARTICLE',
  PAGE_PATH: 'PAGE_PATH'
};

exports.CONTENT_TYPE = exports.$Enums.CONTENT_TYPE = {
  STRING: 'STRING',
  LIST: 'LIST',
  MEDIA: 'MEDIA',
  STRING_LIST: 'STRING_LIST',
  STRING_MEDIA: 'STRING_MEDIA',
  LIST_MEDIA: 'LIST_MEDIA',
  STRING_LIST_MEDIA: 'STRING_LIST_MEDIA'
};

exports.ContactUsFormStatus = exports.$Enums.ContactUsFormStatus = {
  OPEN: 'OPEN',
  RE_OPEN: 'RE_OPEN',
  CLOSED: 'CLOSED',
  ARCHIVED: 'ARCHIVED'
};

exports.DISABLE_RIGHT_CLICK = exports.$Enums.DISABLE_RIGHT_CLICK = {
  NONE: 'NONE',
  ALL: 'ALL',
  IMAGE: 'IMAGE'
};

exports.JOB_EXPRESSION_TYPE = exports.$Enums.JOB_EXPRESSION_TYPE = {
  CUSTOM: 'CUSTOM',
  EVERY_SECOND: 'EVERY_SECOND',
  EVERY_5_SECONDS: 'EVERY_5_SECONDS',
  EVERY_10_SECONDS: 'EVERY_10_SECONDS',
  EVERY_30_SECONDS: 'EVERY_30_SECONDS',
  EVERY_MINUTE: 'EVERY_MINUTE',
  EVERY_5_MINUTES: 'EVERY_5_MINUTES',
  EVERY_10_MINUTES: 'EVERY_10_MINUTES',
  EVERY_30_MINUTES: 'EVERY_30_MINUTES',
  EVERY_HOUR: 'EVERY_HOUR',
  EVERY_2_HOURS: 'EVERY_2_HOURS',
  EVERY_3_HOURS: 'EVERY_3_HOURS',
  EVERY_4_HOURS: 'EVERY_4_HOURS',
  EVERY_5_HOURS: 'EVERY_5_HOURS',
  EVERY_6_HOURS: 'EVERY_6_HOURS',
  EVERY_7_HOURS: 'EVERY_7_HOURS',
  EVERY_8_HOURS: 'EVERY_8_HOURS',
  EVERY_9_HOURS: 'EVERY_9_HOURS',
  EVERY_10_HOURS: 'EVERY_10_HOURS',
  EVERY_11_HOURS: 'EVERY_11_HOURS',
  EVERY_12_HOURS: 'EVERY_12_HOURS',
  EVERY_DAY_AT_1AM: 'EVERY_DAY_AT_1AM',
  EVERY_DAY_AT_2AM: 'EVERY_DAY_AT_2AM',
  EVERY_DAY_AT_3AM: 'EVERY_DAY_AT_3AM',
  EVERY_DAY_AT_4AM: 'EVERY_DAY_AT_4AM',
  EVERY_DAY_AT_5AM: 'EVERY_DAY_AT_5AM',
  EVERY_DAY_AT_6AM: 'EVERY_DAY_AT_6AM',
  EVERY_DAY_AT_7AM: 'EVERY_DAY_AT_7AM',
  EVERY_DAY_AT_8AM: 'EVERY_DAY_AT_8AM',
  EVERY_DAY_AT_9AM: 'EVERY_DAY_AT_9AM',
  EVERY_DAY_AT_10AM: 'EVERY_DAY_AT_10AM',
  EVERY_DAY_AT_11AM: 'EVERY_DAY_AT_11AM',
  EVERY_DAY_AT_NOON: 'EVERY_DAY_AT_NOON',
  EVERY_DAY_AT_1PM: 'EVERY_DAY_AT_1PM',
  EVERY_DAY_AT_2PM: 'EVERY_DAY_AT_2PM',
  EVERY_DAY_AT_3PM: 'EVERY_DAY_AT_3PM',
  EVERY_DAY_AT_4PM: 'EVERY_DAY_AT_4PM',
  EVERY_DAY_AT_5PM: 'EVERY_DAY_AT_5PM',
  EVERY_DAY_AT_6PM: 'EVERY_DAY_AT_6PM',
  EVERY_DAY_AT_7PM: 'EVERY_DAY_AT_7PM',
  EVERY_DAY_AT_8PM: 'EVERY_DAY_AT_8PM',
  EVERY_DAY_AT_9PM: 'EVERY_DAY_AT_9PM',
  EVERY_DAY_AT_10PM: 'EVERY_DAY_AT_10PM',
  EVERY_DAY_AT_11PM: 'EVERY_DAY_AT_11PM',
  EVERY_DAY_AT_MIDNIGHT: 'EVERY_DAY_AT_MIDNIGHT',
  EVERY_WEEK: 'EVERY_WEEK',
  EVERY_WEEKDAY: 'EVERY_WEEKDAY',
  EVERY_WEEKEND: 'EVERY_WEEKEND',
  EVERY_1ST_DAY_OF_MONTH_AT_MIDNIGHT: 'EVERY_1ST_DAY_OF_MONTH_AT_MIDNIGHT',
  EVERY_1ST_DAY_OF_MONTH_AT_NOON: 'EVERY_1ST_DAY_OF_MONTH_AT_NOON',
  EVERY_2ND_HOUR: 'EVERY_2ND_HOUR',
  EVERY_2ND_HOUR_FROM_1AM_THROUGH_11PM: 'EVERY_2ND_HOUR_FROM_1AM_THROUGH_11PM',
  EVERY_2ND_MONTH: 'EVERY_2ND_MONTH',
  EVERY_QUARTER: 'EVERY_QUARTER',
  EVERY_6_MONTHS: 'EVERY_6_MONTHS',
  EVERY_30_MINUTES_BETWEEN_9AM_AND_5PM: 'EVERY_30_MINUTES_BETWEEN_9AM_AND_5PM',
  EVERY_30_MINUTES_BETWEEN_9AM_AND_6PM: 'EVERY_30_MINUTES_BETWEEN_9AM_AND_6PM',
  EVERY_30_MINUTES_BETWEEN_10AM_AND_7PM: 'EVERY_30_MINUTES_BETWEEN_10AM_AND_7PM',
  MONDAY_TO_FRIDAY_AT_1AM: 'MONDAY_TO_FRIDAY_AT_1AM',
  MONDAY_TO_FRIDAY_AT_2AM: 'MONDAY_TO_FRIDAY_AT_2AM',
  MONDAY_TO_FRIDAY_AT_3AM: 'MONDAY_TO_FRIDAY_AT_3AM',
  MONDAY_TO_FRIDAY_AT_4AM: 'MONDAY_TO_FRIDAY_AT_4AM',
  MONDAY_TO_FRIDAY_AT_5AM: 'MONDAY_TO_FRIDAY_AT_5AM',
  MONDAY_TO_FRIDAY_AT_6AM: 'MONDAY_TO_FRIDAY_AT_6AM',
  MONDAY_TO_FRIDAY_AT_7AM: 'MONDAY_TO_FRIDAY_AT_7AM',
  MONDAY_TO_FRIDAY_AT_8AM: 'MONDAY_TO_FRIDAY_AT_8AM',
  MONDAY_TO_FRIDAY_AT_9AM: 'MONDAY_TO_FRIDAY_AT_9AM',
  MONDAY_TO_FRIDAY_AT_09_30AM: 'MONDAY_TO_FRIDAY_AT_09_30AM',
  MONDAY_TO_FRIDAY_AT_10AM: 'MONDAY_TO_FRIDAY_AT_10AM',
  MONDAY_TO_FRIDAY_AT_11AM: 'MONDAY_TO_FRIDAY_AT_11AM',
  MONDAY_TO_FRIDAY_AT_11_30AM: 'MONDAY_TO_FRIDAY_AT_11_30AM',
  MONDAY_TO_FRIDAY_AT_12PM: 'MONDAY_TO_FRIDAY_AT_12PM',
  MONDAY_TO_FRIDAY_AT_1PM: 'MONDAY_TO_FRIDAY_AT_1PM',
  MONDAY_TO_FRIDAY_AT_2PM: 'MONDAY_TO_FRIDAY_AT_2PM',
  MONDAY_TO_FRIDAY_AT_3PM: 'MONDAY_TO_FRIDAY_AT_3PM',
  MONDAY_TO_FRIDAY_AT_4PM: 'MONDAY_TO_FRIDAY_AT_4PM',
  MONDAY_TO_FRIDAY_AT_5PM: 'MONDAY_TO_FRIDAY_AT_5PM',
  MONDAY_TO_FRIDAY_AT_6PM: 'MONDAY_TO_FRIDAY_AT_6PM',
  MONDAY_TO_FRIDAY_AT_7PM: 'MONDAY_TO_FRIDAY_AT_7PM',
  MONDAY_TO_FRIDAY_AT_8PM: 'MONDAY_TO_FRIDAY_AT_8PM',
  MONDAY_TO_FRIDAY_AT_9PM: 'MONDAY_TO_FRIDAY_AT_9PM',
  MONDAY_TO_FRIDAY_AT_10PM: 'MONDAY_TO_FRIDAY_AT_10PM',
  MONDAY_TO_FRIDAY_AT_11PM: 'MONDAY_TO_FRIDAY_AT_11PM'
};

exports.DAYOFWEEK = exports.$Enums.DAYOFWEEK = {
  SUNDAY: 'SUNDAY',
  MONDAY: 'MONDAY',
  TUESDAY: 'TUESDAY',
  WEDNESDAY: 'WEDNESDAY',
  THURSDAY: 'THURSDAY',
  FRIDAY: 'FRIDAY',
  SATURDAY: 'SATURDAY'
};

exports.NOTIFICATION_JOB_STATE = exports.$Enums.NOTIFICATION_JOB_STATE = {
  BEGIN: 'BEGIN',
  END: 'END',
  END_WITH_NOJOB: 'END_WITH_NOJOB',
  END_WITH_FAILURE: 'END_WITH_FAILURE',
  PROCESSING: 'PROCESSING',
  PROCESS_LOCKED: 'PROCESS_LOCKED'
};

exports.NOTIFICATION_CRONJOB_STATUS = exports.$Enums.NOTIFICATION_CRONJOB_STATUS = {
  FAILED: 'FAILED',
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  SUCCESS: 'SUCCESS'
};

exports.NOTIFICATION_CRONJOB_COMMAND = exports.$Enums.NOTIFICATION_CRONJOB_COMMAND = {
  SEND_EMAIL: 'SEND_EMAIL',
  SEND_SMS: 'SEND_SMS'
};

exports.OTPUseCase = exports.$Enums.OTPUseCase = {
  LOGIN: 'LOGIN',
  RESET_PASSWORD: 'RESET_PASSWORD',
  SIGNUP: 'SIGNUP'
};

exports.FieldType = exports.$Enums.FieldType = {
  text: 'text',
  email: 'email',
  number: 'number',
  password: 'password',
  date: 'date',
  textarea: 'textarea',
  select: 'select',
  checkbox: 'checkbox',
  radio: 'radio',
  submit: 'submit',
  consent: 'consent',
  header: 'header',
  paragraph: 'paragraph',
  fullname: 'fullname',
  tel: 'tel',
  privacy: 'privacy',
  upload: 'upload'
};

exports.SHIPPING_METHOD = exports.$Enums.SHIPPING_METHOD = {
  free_shipping: 'free_shipping',
  flat_rate: 'flat_rate'
};

exports.currencyDisplay = exports.$Enums.currencyDisplay = {
  SYMBOL: 'SYMBOL',
  ISO: 'ISO',
  TEXT: 'TEXT'
};

exports.currencyDisplayPosition = exports.$Enums.currencyDisplayPosition = {
  PREFIX: 'PREFIX',
  SUFFIX: 'SUFFIX'
};

exports.MethodType = exports.$Enums.MethodType = {
  TWOC2P: 'TWOC2P',
  TRANSFER: 'TRANSFER',
  NONE: 'NONE',
  COD: 'COD'
};

exports.Prisma.ModelName = {
  CronTask: 'CronTask',
  InterfaceLog: 'InterfaceLog',
  InterfaceCustomerTierLog: 'InterfaceCustomerTierLog',
  InterfaceCustomerTierItemLog: 'InterfaceCustomerTierItemLog',
  InterfaceAX017Log: 'InterfaceAX017Log',
  LogFrontEnd: 'LogFrontEnd',
  LogAxAPI: 'LogAxAPI',
  CronJobExecution: 'CronJobExecution',
  ProductsPromotion: 'ProductsPromotion',
  Account: 'Account',
  Session: 'Session',
  User: 'User',
  UserProfile: 'UserProfile',
  UserCoApplicant: 'UserCoApplicant',
  VerificationToken: 'VerificationToken',
  UserTimeline: 'UserTimeline',
  AAA_DataMigration: 'AAA_DataMigration',
  Staff: 'Staff',
  StaffRole: 'StaffRole',
  MasterPlatform: 'MasterPlatform',
  BackendZone: 'BackendZone',
  Permission: 'Permission',
  Policy: 'Policy',
  CollectionAttb: 'CollectionAttb',
  Collection: 'Collection',
  BrandAttb: 'BrandAttb',
  Brand: 'Brand',
  CategoryAttb: 'CategoryAttb',
  Category: 'Category',
  SubcategoryAttb: 'SubcategoryAttb',
  Subcategory: 'Subcategory',
  Tag: 'Tag',
  MSProductAttb: 'MSProductAttb',
  MSProduct: 'MSProduct',
  MSProductVariantPreset: 'MSProductVariantPreset',
  MSProductDetailAttb: 'MSProductDetailAttb',
  MSProductDetail: 'MSProductDetail',
  MSProductVariantAttb: 'MSProductVariantAttb',
  MSProductVariant: 'MSProductVariant',
  MSProductScore: 'MSProductScore',
  MSProductUserRating: 'MSProductUserRating',
  UserFavProduct: 'UserFavProduct',
  SaleOrder: 'SaleOrder',
  SaleItem: 'SaleItem',
  RunningNumber: 'RunningNumber',
  PaymentTransaction: 'PaymentTransaction',
  SaleOrderTimeline: 'SaleOrderTimeline',
  PagePath: 'PagePath',
  PageLayout: 'PageLayout',
  LayoutComponent: 'LayoutComponent',
  SectionComponentOnPagePath: 'SectionComponentOnPagePath',
  SectionComponent: 'SectionComponent',
  SectionComponentConfig: 'SectionComponentConfig',
  Address: 'Address',
  UserAddress: 'UserAddress',
  CoApplicantAddress: 'CoApplicantAddress',
  OrderAddress: 'OrderAddress',
  Bank: 'Bank',
  WebFooterComponent: 'WebFooterComponent',
  WebFooterSectionAttb: 'WebFooterSectionAttb',
  WebFooterSection: 'WebFooterSection',
  WebFooterItemAttb: 'WebFooterItemAttb',
  WebFooterItem: 'WebFooterItem',
  WebBannerComponent: 'WebBannerComponent',
  BannerItemAttb: 'BannerItemAttb',
  BannerItem: 'BannerItem',
  WebTextLabelAttb: 'WebTextLabelAttb',
  WebTextLabelComponent: 'WebTextLabelComponent',
  WebAdsSectionComponent: 'WebAdsSectionComponent',
  WebAdsSection: 'WebAdsSection',
  WebAdsSectionLayout: 'WebAdsSectionLayout',
  WebAdsItemContentAttb: 'WebAdsItemContentAttb',
  WebAdsItemContent: 'WebAdsItemContent',
  WebAdsItemIconAttb: 'WebAdsItemIconAttb',
  WebAdsItemIcon: 'WebAdsItemIcon',
  WebShortCutAttb: 'WebShortCutAttb',
  WebShortCutComponent: 'WebShortCutComponent',
  ShortCutItemAttb: 'ShortCutItemAttb',
  ShortCutItem: 'ShortCutItem',
  WebMediaAdsComponent: 'WebMediaAdsComponent',
  WebMediaAdsItem: 'WebMediaAdsItem',
  WebNavigationComponent: 'WebNavigationComponent',
  NavigationMenuAttb: 'NavigationMenuAttb',
  NavigationMenu: 'NavigationMenu',
  ItemComponentCondition: 'ItemComponentCondition',
  ContentAtb: 'ContentAtb',
  Content: 'Content',
  ArticleCategoryAttb: 'ArticleCategoryAttb',
  ArticleCategory: 'ArticleCategory',
  ArticleTag: 'ArticleTag',
  ArticleAtb: 'ArticleAtb',
  Article: 'Article',
  ContactUsForm: 'ContactUsForm',
  FaqComponentAttb: 'FaqComponentAttb',
  FaqComponent: 'FaqComponent',
  FaqMenuAttb: 'FaqMenuAttb',
  FaqMenu: 'FaqMenu',
  FaqItemAttb: 'FaqItemAttb',
  FaqItem: 'FaqItem',
  CalendarAttb: 'CalendarAttb',
  CalendarComponent: 'CalendarComponent',
  EventScheduleAttb: 'EventScheduleAttb',
  EventSchedule: 'EventSchedule',
  SystemConfig: 'SystemConfig',
  ContentLanguageConfig: 'ContentLanguageConfig',
  SystemInterfaceConfig: 'SystemInterfaceConfig',
  SystemSiteSettingConfig: 'SystemSiteSettingConfig',
  SystemAccountingConfig: 'SystemAccountingConfig',
  SystemContactConfig: 'SystemContactConfig',
  WebStepInformationComponent: 'WebStepInformationComponent',
  WebStepAttb: 'WebStepAttb',
  WebStep: 'WebStep',
  WebStepItemAttb: 'WebStepItemAttb',
  WebStepItem: 'WebStepItem',
  WebInformationAttb: 'WebInformationAttb',
  WebInformation: 'WebInformation',
  NotificationAction: 'NotificationAction',
  NotificationSchedule: 'NotificationSchedule',
  NotificationExecutionLog: 'NotificationExecutionLog',
  UserNotification: 'UserNotification',
  InAppNotifyTemplateAttb: 'InAppNotifyTemplateAttb',
  InAppNotifyTemplate: 'InAppNotifyTemplate',
  SMSTemplateAttb: 'SMSTemplateAttb',
  SMSTemplate: 'SMSTemplate',
  EmailTemplateAttb: 'EmailTemplateAttb',
  EmailTemplate: 'EmailTemplate',
  NotificationCronJobExecution: 'NotificationCronJobExecution',
  AboutUlifePromoteComponent: 'AboutUlifePromoteComponent',
  AboutUlifePromoteAttb: 'AboutUlifePromoteAttb',
  AboutUlifePromoteElement: 'AboutUlifePromoteElement',
  AboutUlifePromoteElementAttb: 'AboutUlifePromoteElementAttb',
  GridCardComponent: 'GridCardComponent',
  GridCardElement: 'GridCardElement',
  GridCardAttb: 'GridCardAttb',
  HorizontalCardComponent: 'HorizontalCardComponent',
  HorizontalCardElement: 'HorizontalCardElement',
  HorizontalCardElementAttb: 'HorizontalCardElementAttb',
  GalleryComponent: 'GalleryComponent',
  GalleryComponentAttb: 'GalleryComponentAttb',
  AssetManager: 'AssetManager',
  OneTimePassword: 'OneTimePassword',
  Form: 'Form',
  FormField: 'FormField',
  FormSubmission: 'FormSubmission',
  ShippingProfile: 'ShippingProfile',
  ShippingMethod: 'ShippingMethod',
  ShippingMethodTranslation: 'ShippingMethodTranslation',
  CodeAndScript: 'CodeAndScript',
  ShopCurrency: 'ShopCurrency',
  ShopCurrencyAttb: 'ShopCurrencyAttb',
  PaymentMethod: 'PaymentMethod',
  PaymentAttribute: 'PaymentAttribute',
  GeneralStyles: 'GeneralStyles',
  SectionColor: 'SectionColor',
  HeaderComponent: 'HeaderComponent',
  HeaderSection: 'HeaderSection',
  HeaderSectionItem: 'HeaderSectionItem',
  HeaderItem: 'HeaderItem'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        const runtime = detectRuntime()
        const edgeRuntimeName = {
          'workerd': 'Cloudflare Workers',
          'deno': 'Deno and Deno Deploy',
          'netlify': 'Netlify Edge Functions',
          'edge-light': 'Vercel Edge Functions',
        }[runtime]

        let message = 'PrismaClient is unable to run in '
        if (edgeRuntimeName !== undefined) {
          message += edgeRuntimeName + '. As an alternative, try Accelerate: https://pris.ly/d/accelerate.'
        } else {
          message += 'this browser environment, or has been bundled for the browser (running in `' + runtime + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://github.com/prisma/prisma/issues`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
